import React from 'react';
import {Link} from 'react-router';

const HscStatsColumns = ({title = '', columns = []}) => {
    return (
        <React.Fragment>
            <div className={`stats-title green`} style={{marginBottom: 'unset'}}>
                {/* Chatham moved the market-rates page off ChathamDirect to cf.com
                    (Claritask 546891) — same page the rates are now pulled from. */}
                <a href={"https://cf.com/rates/us"} target='_blank'>{title}</a>
            </div>
            <div className="table-container">
                <table className="stats-vertical-table">
                    <thead>
                    <tr>
                        <th className="header-cell"></th>
                        <th className="header-cell">Current</th>
                        <th className="header-cell">1 Yr Prior</th>
                    </tr>
                    </thead>
                    <tbody>
                    {columns.map((row, idx) => (
                        <tr key={idx}>
                        <td className="row-header">{row.label}</td>
                        <td className="row-data">{row.current}</td>
                        <td className="row-data">{row.prior}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                </div>
        </React.Fragment>
    );
};

export default HscStatsColumns;